var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsHtmls"},[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.Data.title)+"\n    ")]),_c('div',{staticClass:"time"},[_vm._v("\n        "+_vm._s(_vm.Data.createTime)+"\n    ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.Data.detailUrl)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }